import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'  
import InputWithExtra from '../../Comman/components/InputWithExtra';
//import Popup from 'reactjs-popup'
import Modal from 'react-responsive-modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TwitterPicker ,ChromePicker,  } from 'react-color';
import 'primereact/resources/primereact.min.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {InputText} from 'primereact/inputtext';
import SimpleReactValidator from 'simple-react-validator';
import noimage from '../../Comman/images/no_image.png';
import loader from '../../Comman/images/loader.gif'
import imageCompression from 'browser-image-compression';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/sv.js';
import 'moment/locale/en-sg.js';
import 'rc-datepicker/lib/style.css';

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}
var svValidator;
var engValidator;
var currentLang;
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
const url=process.env.REACT_APP_SET_URL;
const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
class NotificationAddComponent extends Component {
    toastId = null;
    constructor(props) {
        super(props);
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        var time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes();
        if(dd<10) {
            dd = '0'+dd
        } 
      
        if(mm<10) {
            mm = '0'+mm
        }  
        today =  yyyy+ '-'+ mm + '-' + dd  ;
        this.state = {
            notificationSettings: {
                NotifTypeId:"1",
                NotifCategory:"1",
                NotifHeader:'',
                NotifText:'',                
                NotifPicture: '', 
                NotificationFontType:'Arial',                         
                NotificationFontColor:'#000',
                NotificationFontSize:'', 
                NotificationFontType_Bold:false, 
                NotificationFontType_Itallic:false, 
                NotificationFontType_Underline:false, 
                imagePreviewUrl: '', 
                NotifExpiryDate: '',
                NotifExpiryTime : '',
                NotifSendDate:today,
                NotifSendNow:null,
                NotifSendTime:time,
                RegionId:null,
                inputKey: Date.now()
            },
            open: false,
            rowimage:'',  
            displayFontColorPicker: false,
            todayDate : yyyy+ '-'+ mm + '-' + dd, 
            minDate : yyyy+ '-'+ mm + '-' + dd,
            currentTime : time,
            validateImageField : '',
            validateHeader:'',
            ValidateNotification:''

        };
        this.handleInput = this.handleInput.bind(this);
        this._handleImageChange = this._handleImageChange.bind(this); 
        this.notify=this.notify.bind(this); 
        this.baseState=this.state;
        if(sessionStorage.getItem('Language')){
            currentLang = sessionStorage.getItem('Language');
        }
        else{
            currentLang = "en";
        }
    }
 
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.'
        }); 
        engValidator = new SimpleReactValidator(
            {
                locale : 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale : 'sv'
            }
        );
        this.validator = engValidator;
      }

    componentWillReceiveProps(nextProps) { 
        if (nextProps.notificationSettings !== this.props.notificationSettings) { 
            if(nextProps.statusCode==200){
                this.notify(nextProps.notificationSettings.messageLabel)
            }
            if(nextProps.statusCode==201){
                this.errornotify(nextProps.notificationSettings.messageLabel)
            }
        } 
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
      }

    handleInput(e) {  
       let value = e.target.value;
       let name = e.target.name;
       if(name == "Type"){
            if(value=="bold"){
                if(e.target.checked){
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings,
                            NotificationFontType_Bold:true
                        }, }))
                }
                else{
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings,
                            NotificationFontType_Bold:false
                        }, }))
                }
            }
            if(value=="italic"){
                if(e.target.checked){
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings,
                            NotificationFontType_Itallic:true
                        }, }))
                }
                else{
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings,
                            NotificationFontType_Itallic:false
                        }, }))
                }
            }
            if(value=="underline"){
                if(e.target.checked){
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings,
                            NotificationFontType_Underline:true
                        }, }))
                }
                else{
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings,
                            NotificationFontType_Underline:false
                        }, }))
                }
            }
       }
       else if(name == "NotifSendNow"){ 
        if(value =="Now"){
            value=true; 
        }
        else{
            value=false; 
        }
        this.setState( prevState => ({ notificationSettings : 
            {...prevState.notificationSettings, [name]: value}
          }),  )
       }
       else{
       this.setState( prevState => ({ notificationSettings : 
        {...prevState.notificationSettings, [name]: value}
      }),  )
    }
    }
    handleExpiryDate = (jsDate) => {
        if(jsDate != 'Invalid date'){
            let dd = jsDate.getDate();
            let mm = jsDate.getMonth() + 1;
            let yy = jsDate.getFullYear();
            let date = yy + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
            this.setState( prevState => ({ notificationSettings : 
                {...prevState.notificationSettings,
                    NotifExpiryDate : date
                }
            }),  )
        }
    }
    handleSendDate = (jsDate) =>{
        if(jsDate != 'Invalid date'){
            let dd = jsDate.getDate();
            let mm = jsDate.getMonth() + 1;
            let yy = jsDate.getFullYear();
            let date = yy + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
            this.setState( prevState => ({ notificationSettings : 
                {...prevState.notificationSettings,
                    NotifSendDate : date
                }
            }),  )

            sleep(2000).then(() => {
                this.setState({minDate : this.state.notificationSettings.NotifSendDate});
                console.log("state",this.state)
            })
        }
    }
    errornotify = (message) => { 
        swal({text : message, icon : 'error'})
        // this.toastId =toast.error(message, {
        //   position: toast.POSITION.TOP_CENTER
        // });  
      }

    _handleImageChange(e) {
        let file = e.target.files[0]; 
        var self=this;
        imageCompression(file, options)
        .then(function (compressedFile) {
            self.setState(prevState => ({ notificationSettings : 
                {...prevState.notificationSettings,
                        NotifPicture: file,
                },
            }))
            self.setState({validateImageField : ''}) 
            document.getElementById("currentimgsrc").src = URL.createObjectURL(file);
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    insertNotificationSettings() {
        const { t } = this.props;
        if(this.state.notificationSettings.NotifTypeId == "1" || this.state.notificationSettings.NotifTypeId == "2"){
            if(this.state.notificationSettings.NotifPicture == ""){
                this.setState({validateImageField : `${t('Notification Setting.Picture is required')}` });
                return;
            }
        }
        
        if (this.validator.allValid()) {  
            let notificationSettings = this.state.notificationSettings;    
             const formData = new FormData();
            if(notificationSettings.NotifTypeId == ''){
                this.setState( prevState => ({
                    notificationSettings : 
                    {...prevState.notificationSettings,
                        NotifTypeId: document.getElementById("notificationTypeDD").value, 
                    }  
                  })) 
            }
            if(notificationSettings.NotifCategory == ''){
                this.setState( prevState => ({
                    notificationSettings : 
                    {...prevState.notificationSettings,
                        NotifCategory: document.getElementById("NotifCategoryDD").value, 
                    }  
                  })) 
            }
            if(notificationSettings.NotificationFontType== ''){
                this.setState( prevState => ({
                    notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType: document.getElementById("NotifFontDD").value, 
                    }  
                  })) 
            }
            // sleep(3000).then(() => {  
                notificationSettings = this.state.notificationSettings;   
                if(notificationSettings.NotifSendNow == true){
                    formData.append('SendDate','')
                    formData.append('SchedDate','')
                    formData.append('SchedTime','')
                }
                else{
                    formData.append('SendDate','')
                    formData.append('SchedDate',notificationSettings.NotifSendDate)
                    formData.append('SchedTime',notificationSettings.NotifSendTime)
                }
                if(notificationSettings.NotifTypeId == 1){
                    formData.append('FontType','')
                }
                else{
                    formData.append('FontType',notificationSettings.NotificationFontType)
                }
                formData.append('TextColor',notificationSettings.NotificationFontColor)
                formData.append('TypeId',notificationSettings.NotifTypeId)
                formData.append('CategoryId',notificationSettings.NotifCategory)
                formData.append('Header',notificationSettings.NotifHeader.trim()) 
                formData.append('Text',notificationSettings.NotifText.trim()) 
                formData.append('NotifPicture',notificationSettings.NotifPicture)
                 
                formData.append('FontSize',notificationSettings.NotificationFontSize)
                formData.append('Bold',notificationSettings.NotificationFontType_Bold)
                formData.append('Cursives',notificationSettings.NotificationFontType_Itallic)
                formData.append('Underline',notificationSettings.NotificationFontType_Underline)
                formData.append('Sendnow',notificationSettings.NotifSendNow)
                formData.append('ExpiryDate',notificationSettings.NotifExpiryDate)
                formData.append('ExpiryTime',notificationSettings.NotifExpiryTime)
                 if(notificationSettings.RegionId==null)
          {
            formData.append('RegionId',this.props.notificationSettings.regionList[0].ID)
           
          }
          else{
 formData.append('RegionId',notificationSettings.RegionId)
          }
               
                formData.append('ImageName',notificationSettings.NotifPicture ? notificationSettings.NotifPicture.name:'')
                 this.props.insertNotificationSettings(formData);
            // }) 
        }
        else {
            this.validator.showMessages(); 
            this.forceUpdate();
        }
    } 

    handleError=()=>{
        this.setState({
            rowimage:noimage
         });
    }
 

     notify = (message) => { 
         //debugger
    //   this.toastId =toast.success(message, {
    //     position: toast.POSITION.TOP_CENTER
    //   });  
        swal({text : message, icon : 'success'})
      sleep(1000).then(() => {
        this.props.history.push('/superadmin/detailedNotification')
      })
    } 

    handleFontBtnClick = (event) => { 
        this.setState({ displayFontColorPicker: !this.state.displayFontColorPicker })
    }; 

    handleFontBtnClose = () => {
        this.setState({ displayFontColorPicker: false })
    };
    
    handleFontColorChange = (color, event) => { 
        let fntcolor=color.hex;
        fntcolor.trim();
        this.setState( prevState => ({ notificationSettings : 
          {...prevState.notificationSettings, NotificationFontColor: fntcolor}
        }),  )
        
    };

    render() { 
        const { t } = this.props;
        let  optionNotifType; 
        let NotifTypeVal = this.props.notificationSettings.notificationType;
       
        if(NotifTypeVal){
            optionNotifType = NotifTypeVal.map((NotifTypeValue) =>
                <option value={NotifTypeValue.TypeId} key={NotifTypeValue.TypeId}>{NotifTypeValue.Type}</option>
            );

        }
        let  optionNotifCategory; 
        let NotifCategoryVal = this.props.notificationSettings.notificationCategory;
       
        if(NotifCategoryVal){
            optionNotifCategory = NotifCategoryVal.map((NotifCategoryValue) =>
                <option value={NotifCategoryValue.CategoryId} key={NotifCategoryValue.CategoryId}>{NotifCategoryValue.Notificationcategory}</option>
            );

        }
        let  optionNotifFont; 
        let NotifFontVal = this.props.notificationSettings.fontType;
       
        if(NotifFontVal){
            optionNotifFont = NotifFontVal.map((NotifFontValue) =>
                <option value={NotifFontValue.FontTypeName} key={NotifFontValue.FontTypeName}>{NotifFontValue.FontTypeName}</option>
            );

        }
        
        let {imagePreviewUrl} = this.state.notificationSettings;
        let $imagePreview = null;
        if (imagePreviewUrl) {
          $imagePreview = (<img src={imagePreviewUrl} alt=""/>);
        }
            let  regionListOption; 
      let regionList=this.props.notificationSettings.regionList;
        if(regionList){
            debugger
          regionListOption = regionList.map((item,index) =>
                <option value={item.ID} key={index}>{item.RegionName}</option>
            );
        }
        var header = <div style={{'textAlign':'left'}}>
                        <i className="pi pi-search" style={{margin:'4px 4px 0 0'}}></i>
                        <InputText type="text" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder={t('First_Responder.Search')} size="50"/>
                    </div>;
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Notification Setting.Add Notifications')}</h2>
                </div>
            
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                
                                    <form > 
                                    <div className="form-group">
                                    <div className="row">
                                    <div className="col-md-2 radio-label">
                                                    <label htmlFor="NotifType" className="form-label">{t('Notification Setting.Notification Types')}</label>
                                                </div> 
                                <div className="col-md-9">
                                    <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-bell-o" aria-hidden="true"></i>
                                      </span>
                                        <select  id="notificationTypeDD"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.NotifTypeId}
                                            placeholder="Select" 
                                            ref="NotifTypeId"
                                            name='NotifTypeId'
                                        >
                                            {optionNotifType}
                                        </select>
                                    </div> 
                                     {/* {this.validator.message('NotifTypeId', this.state.NotifTypeId, 'required')} */}
                                </div></div> 
                            </div> 
                            <div className="form-group">
                                    <div className="row">
                                    <div className="col-md-2 radio-label">
                                                    <label htmlFor="NotifCategory" className="form-label">{t('Notification Setting.Notification Category')}</label>
                                                </div> 
                                <div className="col-md-9">
                                    <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-bell-o" aria-hidden="true"></i>
                                      </span>
                                        <select  id="NotifCategoryDD"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.NotifCategory}
                                            placeholder="Select" 
                                            ref="NotifCategory"
                                            name='NotifCategory'
                                        >
                                            {optionNotifCategory}
                                        </select>
                                    </div> 
                                     {/* {this.validator.message('NotifCategory', this.state.NotifCategory, 'required')} */}
                                </div></div> 
                            </div> 
                            <div className="form-group">
                                    <div className="row">
                                    <div className="col-md-2 radio-label">
                                             <label htmlFor="RegionName" className="form-label">Region</label>
                                                </div> 
                                <div className="col-md-9">
                                    <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-area-chart" aria-hidden="true"></i>
                                      </span>
                                          <select  id="regionData"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.notificationSettings.RegionId}
                                            placeholder="Select" 
                                            ref="regionData"
                                            name= {'RegionId'}
                                            
                                        >
                                          
                                            {regionListOption}
                                        </select>
                                    </div> 
                                     {/* {this.validator.message('NotifCategory', this.state.NotifCategory, 'required')} */}
                                </div></div> 
                            </div> 
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label htmlFor="NotifHeader" className="form-label">{t('Notification Setting.Notification Header')}</label>
                                                </div>
                                                <div className="col-md-9">
                                                    <div className="input-group noti-text-field">
                                                    <textarea rows={3} 
                                                    type={'text'}
                                                    title= {t('Notification Setting.Notification Header')}
                                                    name= {'NotifHeader'}
                                                    defaultValue={this.state.notificationSettings.NotifHeader} 
                                                    placeholder = {t('Notification Setting.Enter Notification Header')}
                                                    onChange = {this.handleInput} 
                                                    />  
                                                    {this.validator.message(`${t('Notification Setting.Notification Header')}`, this.state.notificationSettings.NotifHeader, 'required|min:2')}
                                                </div>
                                                </div>
                                            </div>
                                        </div> 
                            {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3")?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label htmlFor="NotifText" className="form-label">{t('Notification Setting.Notification Text')}</label>
                                                </div>
                                                <div className="col-md-9">
                                                <div className="input-group noti-text-field">
                                                    <textarea rows={4}
                                                        id={'NotifText'}
                                                        name={'NotifText'}
                                                        title= {t('Notification Setting.Notification Text')}
                                                        defaultValue={this.state.notificationSettings.NotifText} 
                                                        placeholder = {t('Notification Setting.Enter Notification Text')}
                                                        onChange = {this.handleInput}  
                                                    />
                                                </div> 
                                                    {/* <InputWithExtra 
                                                    type={'text'}
                                                    title= {'NotifText'} 
                                                    name= {'NotifText'}
                                                    defaultValue={this.state.notificationSettings.NotifText} 
                                                    placeholder = {'Enter Notification Text'}
                                                    onChange = {this.handleInput} 
                                                    />   */}
                                                    {this.validator.message(`${t('Notification Setting.Notification Text')}`, this.state.notificationSettings.NotifText, 'required|min:2')}
                                                 </div>
                                            </div>
                            </div>:"" }
                            {(this.state.notificationSettings.NotifTypeId == "1" || this.state.notificationSettings.NotifTypeId == "2")?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Notification Setting.Notification Picture')}</label> 
                                                </div>
                                                <div className="col-md-8">        
                                                        <img className="notifi-img" src="" id="currentimgsrc" alt="" />                      
                                                        <input accept="image/*" type="file" name={'NotifPicture'} title={t('Notification Setting.Notification Picture')} 
                                                            key={this.state.inputKey} onChange={this._handleImageChange} id="imageUpload" className="hide_input_type_file"/>
                                                        <label for="imageUpload" className="choose-file-btn">{t('Notification Setting.Select Image')}</label>
                                                        {/* {this.validator.message('NotifPicture', this.state.notificationSettings.NotifPicture, 'required')} */}
                                                        <p style={{"color":'red'}}>{this.state.validateImageField}</p>
                                                </div>
                                                </div>
                                            </div>:''}
                                            
                                            <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Notification Setting.Text Font Color')}</label> 
                                                </div>
                                                <div className="col-md-4 m-b-15">
                                                    <TwitterPicker  
                                                        color={ this.state.notificationSettings.NotificationFontColor }
                                                        onChangeComplete={ this.handleFontColorChange }
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    
                                                    <ChromePicker 
                                                       color={ this.state.notificationSettings.NotificationFontColor }
                                                        onChangeComplete={ this.handleFontColorChange } 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3")?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label htmlFor="FontSize" className="form-label">{t('Notification Setting.Text Font Size')}</label>
                                                </div>
                                                <div className="col-md-9">

                                                    <InputWithExtra 
                                                        type={'number'}
                                                        title= {t('Notification Setting.Text Font Size')} 
                                                        name= {'NotificationFontSize'}
                                                        defaultValue={this.state.notificationSettings.NotificationFontSize} 
                                                        placeholder = {t('Notification Setting.Enter Font Size')}
                                                        onChange = {this.handleInput}
                                        
                                                        />
                                                    {this.validator.message(`${t('Notification Setting.Text Font Size')}`, this.state.notificationSettings.NotificationFontSize, 'alpha_num_space|min:2')}
                                                        
                                                </div>
                                            </div>
                                        </div> : '' }
                                        {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3")?
                                        <div className="form-group">
                                    <div className="row">
                                    <div className="col-md-2 radio-label">
                                                    <label htmlFor="NotifFont" className="form-label">{t('Notification Setting.Notification Font')}</label>
                                                </div> 
                                <div className="col-md-9">
                                    <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-bell-o" aria-hidden="true"></i>
                                      </span>
                                        <select  id="NotifFontDD"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.NotificationFontType}
                                            placeholder="Select" 
                                            ref="NotificationFontType"
                                            name='NotificationFontType'
                                        >
                                            {optionNotifFont}
                                        </select>
                                    </div> 
                                 </div></div> 
                            </div>   : '' }
                            {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3")?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Notification Setting.Text Font Type')}</label> 
                                                </div>
                                                <div className="col-md-8">
                                                            <div className="input-group">
                                                              <div className="checkbox setting-radio">
                                                                <label key="NotificationFontType" className="checkbox-inline">
                                                                    <input 
                                                                      id = "FontType_Bold"
                                                                      name="Type"
                                                                      onChange={this.handleInput}
                                                                      value="bold"
                                                                      key="bold" 
                                                                      type="checkbox" /> <i className="fa fa-bold" aria-hidden="true"></i>
                                                                  </label>
                                                                  <label  className="checkbox-inline" >
                                                                    <input 
                                                                      id = "FontType_Itallic"
                                                                      name="Type"
                                                                      onChange={this.handleInput}
                                                                      value="italic"
                                                                      key="italic" 
                                                                      type="checkbox" /> <i className="fa fa-italic" aria-hidden="true"></i>
                                                                  </label>
                                                                  <label className="checkbox-inline" >
                                                                    <input 
                                                                      id = "FontType_Underline"
                                                                      name="Type"
                                                                      onChange={this.handleInput}
                                                                      value="underline"
                                                                      key="underline" 
                                                                      type="checkbox" /> <i className="fa fa-underline" aria-hidden="true"></i>
                                                                  </label>
                                                              </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                            </div> : ''}
                                            <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Notification Setting.Send Date and Time')}</label> 
                                                </div>
                                                <div className="col-md-8">
                                                            <div className="input-group">
                                                              <div className="checkbox setting-radio">
                                                                <label key="NotificationFontType" className="checkbox-inline" value="Send Now">
                                                                    <input style={{display:'inline'}}
                                                                      id = "NotifSendNow"   
                                                                      name="NotifSendNow"
                                                                      onChange={this.handleInput}
                                                                      value="Now"
                                                                      key="Now" 
                                                                      type="radio"
                                                                       />  {t('Notification Setting.Send Now')}
                                                                  </label>
                                                                  <label  className="checkbox-inline" >
                                                                    <input  style={{display:'inline'}}
                                                                      id = "NotifSendNow"
                                                                      name="NotifSendNow"
                                                                      onChange={this.handleInput}
                                                                      value="Later"
                                                                      key="Later" 
                                                                      type="radio" />  {t('Notification Setting.Schedule Later')}
                                                                  </label>
                                                                  {this.validator.message(`${t('Notification Setting.Send Date and Time')}`, this.state.notificationSettings.NotifSendNow, 'required')}
                                                              </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label"> </label> 
                                                </div>
                                                <div className="col-md-9">
                                                    {
                                                        this.state.notificationSettings.NotifSendNow == false ?
                                                        <div>
                                                           {/* <InputWithExtra 
                                                           type={'date'}
                                                           title= {t('Notification Setting.Notification send date')} 
                                                           name= {'NotifSendDate'} 
                                                            value={this.state.notificationSettings.NotifSendDate} 
                                                           placeholder = {''}
                                                           onChange = {this.handleInput} 
                                                           min = {this.state.todayDate}
                                                           /> */}
                                                        <DatePickerInput
                                                            locale={currentLang} 
                                                            value={this.state.notificationSettings.NotifSendDate}
                                                            onChange={this.handleSendDate}
                                                            title= {t('Notification Setting.Notification send date')}
                                                            minDate = {this.state.todayDate}
                                                            displayFormat='YYYY-MM-DD'
                                                            returnFormat='YYYY-MM-DD'
                                                            showOnInputClick
                                                        />
                                                           <br/>
                                                            <InputWithExtra 
                                                            type={'time'}
                                                            title= {t('Notification Setting.Notification send time')} 
                                                            name= {'NotifSendTime'} 
                                                            value={this.state.notificationSettings.NotifSendTime} 
                                                            placeholder = {''}
                                                            onChange = {this.handleInput} 
                                                            
                                                           /> 
                                                        </div> 
                                                           : ''
                                                    }
                                                    {   this.state.notificationSettings.NotifSendNow == true ?
                                                        <div>
                                                            <p>{t('Notification Setting.Date')} : {this.state.todayDate} </p>
                                                            <p>{t('Notification Setting.Time')} : {this.state.currentTime}</p>
                                                        </div> : ''
                                                    }
                                                        </div>
                                                        
                                                    </div>
                                            </div> 
                                            <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Notification Setting.Expiry Date and Time')}</label> 
                                                </div>
                                                <div className="col-md-9">
                                                {/* <InputWithExtra 
                                                    type={'date'}
                                                    title= {t('Notification Setting.Notification expiry date')} 
                                                    name= {'NotifExpiryDate'} 
                                                     value={this.state.notificationSettings.NotifExpiryDate} 
                                                    placeholder = {''}
                                                    onChange = {this.handleInput} 
                                                    min = {this.state.minDate}
                                                    /> */}
                                                <DatePickerInput
                                                    locale={currentLang} 
                                                    value={this.state.notificationSettings.NotifExpiryDate}
                                                    onChange={this.handleExpiryDate}
                                                    title= {t('Notification Setting.Notification expiry date')}
                                                    minDate = {this.state.minDate}
                                                    displayFormat='YYYY-MM-DD'
                                                    returnFormat='YYYY-MM-DD'
                                                    showOnInputClick
                                                />
                                                <br/>      
                                                <InputWithExtra 
                                                    type={'time'}
                                                    title= {t('Notification Setting.Notification expiry time')} 
                                                    name= {'NotifExpiryTime'} 
                                                    value={this.state.notificationSettings.NotifExpiryTime} 
                                                    placeholder = {''}
                                                    onChange = {this.handleInput} 
                                                    />  
                                                        </div> 
                                                    </div>
                                                     
                                            </div> 
                                            <div className="form-group"> 
                                                <div className="col-sm-offset-5 col-sm-6">      
                                                <p className='butn-center'>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-primary general-btn" 
                                                    onClick={() => { this.insertNotificationSettings() }}
                                                    disabled={this.props.notificationSettings.isLoading == true}
                                                >
                                                    {t('First_Responder.Save')}
                                                </button>
                                                {
                                                    this.props.notificationSettings.isLoading?  
                                                    <img src={loader} width="30" alt="" />:''
                                                }
                                                </p>
                                                </div>
                                            </div>
                                       
                                       
                                    </form>  
                            </div>
                        </div>
                    </div>     
                   {/* <ToastContainer />  */}
                        
                </div>  
            </div>
        )
    }
}

export default withNamespaces()(withRouter(NotificationAddComponent));